<template>
  <div class="col-9">
    <slot />
  </div>
</template>
